const APP_VERSION_NUMBER = '0.9.15';

//const APP_ENV = 'LOCAL';
//const APP_ENV = 'DEV';
const APP_ENV = 'PROD';

//const APP_ENV = 'DEMO';
//const APP_ENV = 'DEMO2';
//const APP_ENV = 'DEMO3';
//const APP_ENV = 'EXPORT';

const APP_CONFIG = {
  LOCAL: {
    IS_LOCAL: true,
    ENV: 'development',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'http://localhost:3000',
    API_URL: 'http://localhost:5000/velocity-app-development/us-central1',
    //API_URL: 'http://localhost:5001/velocity-app-development/us-central1',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyChqcfZefaCOdRG7t_2qi27YKNdm_AVBlE",
      authDomain: "velocity-app-development.firebaseapp.com",
      databaseURL: "https://velocity-app-development.firebaseio.com",
      projectId: "velocity-app-development",
      storageBucket: "velocity-app-development.appspot.com",
      messagingSenderId: "239057015867",
    },
    SENTRY_CONFIG: {
      DSN: 'https://ffa7ff81a6a542be980e190db24980b3@sentry.io/1289192'
    },
  },
  DEV: {
    ENV: 'development',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'https://dev.velocitytalent.com',
    API_URL: 'https://dev.velocitytalent.com/api',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyChqcfZefaCOdRG7t_2qi27YKNdm_AVBlE",
      authDomain: "velocity-app-development.firebaseapp.com",
      databaseURL: "https://velocity-app-development.firebaseio.com",
      projectId: "velocity-app-development",
      storageBucket: "velocity-app-development.appspot.com",
      messagingSenderId: "239057015867",
      appId: "1:239057015867:web:8d7f3d0e4490f5e791781e"
    },
    SENTRY_CONFIG: {
      DSN: 'https://ffa7ff81a6a542be980e190db24980b3@sentry.io/1289192'
    },
  },
  PROD: {
    ENV: 'production',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'https://app.velocitytalent.com',
    API_URL: 'https://app.velocitytalent.com/api',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyDdD1fnECDvnbEHzgCa07HlggO1HsUmdVU",
      authDomain: "velocity-app-prod-v0.firebaseapp.com",
      databaseURL: "https://velocity-app-prod-v0.firebaseio.com",
      projectId: "velocity-app-prod-v0",
      storageBucket: "velocity-app-prod-v0.appspot.com",
      messagingSenderId: "658884153268",
      appId: "1:658884153268:web:ac7c97e190d0d9fad42ce1",
    },
    SENTRY_CONFIG: {
      DSN: 'https://d285140634754114abffa274c8f8023b@sentry.io/1289187'
    }
  },
  DEMO: {
    ENV: 'demo',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'http://demo.velocitytalent.com',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyB421iyUbONy4EQXgvYbJ3hYywhtl6NzZo",
      authDomain: "velocity-app-demo.firebaseapp.com",
      databaseURL: "https://velocity-app-demo.firebaseio.com",
      projectId: "velocity-app-demo",
      storageBucket: "velocity-app-demo.appspot.com",
      messagingSenderId: "847000432096"
    },
    SENTRY_CONFIG: {
      DSN: 'https://cfdd9af77f394355801b5b78bcef2f1f@sentry.io/1331019'
    }
  },
  DEMO2: {
    ENV: 'demo',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'http://demo2.velocitytalent.com',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyB3NMUqXmlTv3gF86QBEgBpU7W7CugQYXQ",
      authDomain: "velocity-app-demo2.firebaseapp.com",
      databaseURL: "https://velocity-app-demo2.firebaseio.com",
      projectId: "velocity-app-demo2",
      storageBucket: "velocity-app-demo2.appspot.com",
      messagingSenderId: "556696522102"
    },
    SENTRY_CONFIG: {
      DSN: 'https://cfdd9af77f394355801b5b78bcef2f1f@sentry.io/1331019'
    }
  },
  DEMO3: {
    ENV: 'demo',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'http://demo3.velocitytalent.com',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyC-28Eyx0dkLo9xgmAqUBtSo2YMDH1KInk",
      authDomain: "velocity-app-demo3.firebaseapp.com",
      databaseURL: "https://velocity-app-demo3.firebaseio.com",
      projectId: "velocity-app-demo3",
      storageBucket: "velocity-app-demo3.appspot.com",
      messagingSenderId: "124029572973"
    },
    SENTRY_CONFIG: {
      DSN: 'https://cfdd9af77f394355801b5b78bcef2f1f@sentry.io/1331019'
    }
  },
  EXPORT: {
    ENV: 'export',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'http://localhost:3000',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyAbtnlqkbK_na0uzNyyAdMMmqOB2MPab4I",
      authDomain: "velocity-report-export.firebaseapp.com",
      databaseURL: "https://velocity-report-export.firebaseio.com",
      projectId: "velocity-report-export",
      storageBucket: "",
      messagingSenderId: "766557383813"
    },
  },
}

export default APP_CONFIG[APP_ENV];

export const ALL_CONFIGS = APP_CONFIG;



// WEBPACK FOOTER //
// ./src/config.js